// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1HOyn","legacyBtn":"MutateMid_legacyBtn__uUxAv"};